(function($) {
	formHelper.addRule({
		form: '.form-unsubscribe',
		xhrBeforeSend: function() {
			$('.js-fh-success-custom').html('');
			$('.js-fh-success-custom').hide();
		},
		status: {
			SUCCESS: function() {
				if (this.data.successMessage) {
					$('.js-fh-success-custom').html(this.data.successMessage);
					$('.js-fh-success-custom').show();
				}
			},
			ERROR: function() {
				if (this.data.errorMessage) {
					$('.js-fh-error-custom').html(this.data.errorMessage);
				}
			}
		}
	});
})(jQuery);